










import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import _ from 'lodash';

@Component
export default class extends Mixins() {
  @Prop() value!: any;

  value1: any[] = [];

  @Watch('value')
  watchValue(val: any, oldVal: any) {
    if (!_.isEqual(val, oldVal)) {
      if (oldVal == '') {
        oldVal = [];
      }
      if (val == '') {
        val = [];
      }

      this.value1 = val;
    }
  }

  treeData: any = [];

  changeTree(value: any, label: any, extra: any) {
    this.$emit('change', value);
  }

  async loadZones() {
    const res = await this.$store.dispatch('adserver/selZones', {});
    if (res && res.Data) {
      this.treeData = res.Data;
    }
  }

  mounted() {
    this.loadZones();
  }
}
